import {
  Get,
  Post,
} from './http'

// 获取验证码
let getQuery = function (params) {
  return Post('/invoicings/admin/getQuery.action', params)
}

// 发送验证码
let sendSMS = function (params) {
  return Post('/invoicings/SMSVerification/sendSMS.action', params)
}

//注册
let addAdmin = function (params) {
  return Post('/invoicings/admin/addAdmin.action', params)
}
//判断账号是否存在
let isRegister = function (params) {
  return Post('/invoicings/admin/isRegister.action', params)
}
//根据手机号查询客户经理信息
let getSysUserInfoByPromoCode = function (params) {
  return Post('/invoicings/sys/user/getSysUserInfoByPromoCode.action', params)
}
//客户经理登录
let sysUserLogin = function (params) {
  return Post('/invoicings/sys/user/sysUserLogin.action', params)
}
//公众号用户绑定掌大师用户
let wxGzhBindUser = function (params) {
  return Post('/invoicings/wxuser/wxGzhBindUser.action', params)
}
//外部用户查询已绑定的店铺
let searchBindShopByPhone = function (params) {
  return Post('/invoicings/otwxuser/searchBindShopByPhone.action', params)
}
//外部用户通过获取手机号获取该手机未绑定的所有商铺
let searchShopByPhone = function (params) {
  return Post('/invoicings/otwxuser/searchShopByPhone.action', params)
}
//外部用户通过获取手机号获取该手机未绑定的所有商铺
let wxUserBindShop = function (params) {
  return Post('/invoicings/otwxuser/wxUserBindShop.action', params)
}
//查询销售单列表
let getMarketListWx = function (params) {
  return Post('/invoicings/wmarket/getMarketListWx.action', params)
}
//查询客户分析
let customerAnalysisWx = function (params) {
  return Post('/invoicings/customer/customerAnalysisWx.action', params)
}
//查询客户分析总计
let customerAnalysisTotalWx = function (params) {
  return Post('/invoicings/customer/customerAnalysisTotalWx.action', params)
}
//查询单详情
let getMarketIdWx = function (queryUrl,params) {
  return Post(queryUrl, params)
}
//删除店铺
let wxUpdateCustomer = function (params) {
  return Post('/invoicings/otwxuser/wxUpdateCustomer.action', params)
}


let getWeixinAppSchemeURL = id => {
  return Post('invoicings/wxuser/getWxAppletMsg.action', {
    path: "pages/index/index",
    query: `id=${id}`
  });
}

export const $Api = {
  wxUpdateCustomer: wxUpdateCustomer,
  getMarketIdWx: getMarketIdWx,
  getWeixinAppSchemeURL: getWeixinAppSchemeURL,
  getMarketListWx: getMarketListWx,
  customerAnalysisWx: customerAnalysisWx,
  wxUserBindShop: wxUserBindShop,
  customerAnalysisTotalWx: customerAnalysisTotalWx,
  searchBindShopByPhone: searchBindShopByPhone,
  searchShopByPhone: searchShopByPhone,
  getQuery: getQuery,
  addAdmin: addAdmin,
  isRegister:isRegister,
  sendSMS:sendSMS,
  getSysUserInfoByPromoCode:getSysUserInfoByPromoCode,
  sysUserLogin:sysUserLogin,
  wxGzhBindUser:wxGzhBindUser
}



// WEBPACK FOOTER //
// ./src/api/api.js